import { ListingCategory } from '../../listing-catagories/listing-category.model';
import { ListingSubCategory } from '../../listing-catagories/listing-sub-category.model';

export class Listing {
  public ListingID: number;
  public ProfileID: number;
  public CategoryID: number;
  public SubCategoryID: number;
  public DisplayName: string;
  public Website: string;
  public Email: string;
  public Descr: string;
  public Expires: boolean;
  public Keywords: string;
  public WebListing: boolean;
  public PrintListing: boolean;
  public PrimaryListing: boolean;
  public Active: boolean;
  public Directions: string;
  public Address1: string;
  public Address2: string;
  public City: string;
  public State: string;
  public Zip: string;
  public ZipExt: string;
  public SoldBy: number;
  public ChangedBy: string;
  public DateCreated: Date;
  public DateChanged: Date;
  public BusinessLogo: string;
  public ListingPrefix: string;
  public DefaultAppearance: boolean;
  public ColorHighLightBox: string;
  public ColorFont: string;
  public ColorBorder: string;
  public BorderSize: number;
  public FontStyle: string;
  public FontSize: number;
  public ShowMap: boolean;
  public ShowAddress: boolean;
  public ShowPhone: boolean;
  public ShowFax: boolean;
  public ShowBusDescr: boolean;
  public ShowWebsite: boolean;
  public ShowEmail: boolean;
  public Longitude: string;
  public Latitude: string;
  public MapURL: string;
  public ListingNotes: string;
  public HTMLOverride: string;
  public WebsiteRedirect: string;
  public DateExpires: Date;
  public Phone: string;
  public Phone2: string;
  public Fax: string;
  public Rep: string;
  public OverrideProfileSettings: boolean;
  public OverrideSystemPreferences: boolean;
  public RotateOrder: number;
  public EntityID: number;
  public ListingTypeID: number;
  public ShortDescr: string;
  public ProductsAndServices: string;
  public DetailsListingTypeID: number;
  public MobileAppListingTypeID: number;

  public ListingCategory: ListingCategory;
  public ListingSubCategory: ListingSubCategory;
  public CategorySubCategory: string;

  public RelatedProfileIdOverride?: number;
}
